export default __webpack_public_path__ + "static/media/camera-flip.08d104a5.svg";